import { useTranslation } from 'react-i18next';
import { trackButtonClick, trackNavigation } from '../../utils/analytics';
import './Footer.css';

// Build metadata injected at build time
declare const __APP_VERSION__: string;
declare const __BUILD_DATE__: string;

export default function Footer() {
  const { t } = useTranslation();

  const buildDate = new Date(__BUILD_DATE__).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  const handleFooterLinkClick = (linkName: string, target: string) => {
    trackButtonClick(linkName, 'footer');
    trackNavigation('home', target, 'footer_link_click');
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-brand">
          <h3>eZunity</h3>
          <p>{t('footer.tagline')}</p>
        </div>
        <div className="footer-links">
          <a href="#features" onClick={() => handleFooterLinkClick('about', 'features')}>{t('footer.links.about')}</a>
          <a href="#cta" onClick={() => handleFooterLinkClick('contact', 'cta')}>{t('footer.links.contact')}</a>
          <a href="#hero" onClick={() => handleFooterLinkClick('privacy', 'hero')}>{t('footer.links.privacy')}</a>
          <a href="#hero" onClick={() => handleFooterLinkClick('terms', 'hero')}>{t('footer.links.terms')}</a>
        </div>
        <div className="footer-copyright">
          <p>{t('footer.copyright')}</p>
          <p className="footer-version">
            v{__APP_VERSION__} • {buildDate}
          </p>
        </div>
      </div>
    </footer>
  );
}
